module.exports = __webpack_public_path__ + "img/check_success.svg";